<template>
        <v-card class="my-custom-card">
            
            <v-app-bar class="mb-5" flat color="transparent">
                <v-btn large icon @click="$emit('cancel')">
                    <v-icon color="primary" @click="$router.push('/issuanceIncoice')">mdi-arrow-left</v-icon>
                </v-btn>

                <v-toolbar-title class="title">
                    Criar Pré-Nota
                </v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn color="primary" @click="createEmitNf">
                    <span>
                        Salvar
                    </span>
                </v-btn>
        
            </v-app-bar>

            <v-container> </v-container>

            <v-form :key="componentKey" ref="formPrincipal" class="d-flex flex-column gap-5">

                <div v-if="emitNotaFiscal.typeNf != 'Nota Fiscal de Serviço'">

                    <v-expansion-panels class="mb-5">
                        <v-expansion-panel v-if="emitNotaFiscal.notaFiscalDeRemessa == false && emitNotaFiscal.typeNf != 'Nota Fiscal de Serviço'">
                            <v-expansion-panel-header class="font-weight-bold">
                                Nota Referenciada
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <div style="display: flex; justify-content: center; align-items: center; gap: 5px;">
                                    <v-text-field style="margin-right: 5px;" learable outlined label="Nota Fiscal Mãe (Chave Acesso)" v-model="searchNotaChaveAcesso" />
                                    <v-btn @click.stop.prevent="searchNotaFisca" style="margin-bottom: 20px;" color="primary" :disabled="!searchNotaChaveAcesso || loadingSearchNota" :loading="loadingSearchNota">
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </div>
                                    <v-data-table
                                        v-model="selected"
                                        :headers="headers"
                                        :items="itemsData"
                                        class="elevation-1"
                                        disable-sort
                                        hide-default-footer
                                        show-select 
                                        color="primary"
                                        single-select
                                    >
                                        <template  v-slot:[`item.valueNf`]="{ item }">
                                            <span>
                                                {{ formatCurrencyValueNf(item) }}
                                            </span>
                                        </template>
                                </v-data-table>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-row>
                        <v-col cols="12" sm="6" md="4" v-if="emitNotaFiscal.typeNf != 'Nota Fiscal de Serviço'">
                            <v-autocomplete 
                                clearable 
                                outlined 
                                label="Job" 
                                v-model="notaFiscal.job" 
                                :items="projects" 
                                item-value="id"
                                item-text="code"
                                return-object
                                :loading="loadingProjects"
                                @change="slectedJob"
                            />
                        </v-col>

                        <v-col cols="12" sm="6" md="4" v-if="emitNotaFiscal.notaFiscalDeRemessa && emitNotaFiscal.typeNf != 'Nota Fiscal de Serviço'">

                            <v-autocomplete 
                                clearable outlined label="Fornecedor" 
                                v-model="emitNotaFiscal.destinatario" 
                                :items="fornecedores" 
                                item-value="id"
                                :item-text="(f) => f.codigo ? `${f.codigo} - ${f.nomeFantasia}` : f.nomeFantasia"
                                @change="fornecedorSelected"
                                return-object
                                :loading="loadingFornecedores"
                            />
                        </v-col>
                        
                        <v-col cols="12" sm="6" md="4" v-else>

                            <v-autocomplete 
                                clearable outlined label="Cliente" 
                                v-model="emitNotaFiscal.destinatario" 
                                :items="clientes" 
                                item-value="id"
                                item-text="nomeFantasia"
                                return-object
                                :loading="loadingClientes"
                            />
                        </v-col>
                        
                        <v-col cols="12" sm="6" md="4" :key="updtaeSum">
                            <v-text-field 
                                clearable outlined 
                                label="Valor Total da Nota"
                                
                                :value="formatMoeda(emitNotaFiscal.valorNf / 100)"
                                :readonly="emitNotaFiscal.typeNf !== 'Nota Fiscal de Serviço'"
                            />
                        </v-col>
                        <!-- <v-col cols="12" sm="6" md="3">
                            <v-combobox 
                                label="Status da Nota" 
                                :items="optionStatus" 
                                outlined 
                                clearable 
                                v-model="emitNotaFiscal.statusNf"
                            ></v-combobox>
                        </v-col> -->

                </v-row>
                </div>

                <div v-if="emitNotaFiscal.typeNf != 'Nota Fiscal de Serviço'">
                    <NotaFiscal 
                        :item="notaFiscal"
                        :projects="projects"
                        :userInfo="emitNotaFiscal.destinatario"
                        :pacelasCads="parcelas"
                        :valorNota="emitNotaFiscal.valorNf"
                        :jobSelected="notaFiscal.job"
                        :romaneios="romaneios"
                        :isNfRemessa="emitNotaFiscal.notaFiscalDeRemessa"
                        :isNfReferenciada="isCfopsNfMae.includes(this.notaFiscal.cfop)"
                        :isDuplicating="isDuplicating"
                        ref="nfComponent"
                        @itens-nf="handleNfItens"
                        @nf="handleNotaFiscal"
                        @sumItens="updateSum"
                        @parcelas="handleParcelas"
                    />
                </div>

                <div v-else>
                    <NotaFiscalServico 
                        :item="objeNotaServico"
                        :projects="projects"
                        :userInfo="emitNotaFiscal.destinatario"
                        :isOpen="dialog"
                        :valorNf="emitNotaFiscal.valorNf"
                        :clientes="clientes"
                        @selectedCliente="selectedCliente"
                        @nf="handleNotaFiscalServico"
                        :pacelasCads="parcelas"
                        @parcelas="handleParcelas"
                    />
                </div>
            </v-form>

        </v-card>
</template>

<script>
import Vue from 'vue';
import NotaFiscal from './formCreateNF/NotaFiscal.vue';
import NotaFiscalServico from './formCreateNF/NotaFiscalServico.vue';
import {VMoney} from 'v-money'
import moment from 'moment';
import EntityService from '../../services/entityService';
export default {
    name: 'CreateIssuanceInvoice',
    //props: ['item'],
    directives: { money: VMoney },
    components: {
        NotaFiscal,
        NotaFiscalServico
    },
    data(){
        return {
            fisDocEntity: new EntityService('FisDocService'),
            fisPreDocEmi: new EntityService('FisPreDocEmi'),
            emissaoDoc: new EntityService('EmissaoNotasFiscais'),
            optionStatus: ['Pendente', 'Emitida', 'Rejeitado', 'Denegada'],
            dialog: false,
            projects: [],
            parcelas: [],
            isCfopsNfMae: ['6922'],
            item: null,
            isDuplicating: false,
            emitNotaFiscal: {
                notaFiscalDeRemessa: this.$route.params.typeNf == 'Nota Fiscal de Remessa' ? true : false,
                typeNf: 'Nota Fiscal',    
                valorNf: null,
                destinatario: null,
                statusNf: 'Pendente'
            },
            componentKey: 0,
            updtaeSum: 0,
            selected: [],
            itemsData: [],
            notaFiscal: {
                filial: '',
                job: '',
                ncm: '',
                romaneio: [],
                cest: '',
                icms: '',
                baseIcms: '',
                naturezaOp: '',
                cfop: '',
                cnpj: '',
                itens: [],
                uf: '',
                email: '',
                bairro: '',
                numero: '',
                logradouro: '',
                cidade: '',
                cep: '',
                condPag: '',
                codigoCidade: '',
                transportadora: '',
                notaFiscalMae: null,
                codigoBeneficioFiscal: ''
            },
            objeNotaServico: {
                cnpj: null,
                cpfOrCnpjEmitente: null,
                razaoSocialNomeEmitente: null,
                cpfOrCnpjTomador: null,
                razaoSocialNomeTomador: null,
                cnae: null,
                inscricaoMinucipal: '',
                inscricaoMinucipalTomador: '',
                endereco: null,
                localEmissao: null,
                emitenteLogradouro: null,
                emitenteBairro: null,
                localRecebimento: null,
                tipoServico: '',
                descricao: '',
                enqServico: '',
                codMunicipio: '',
                job: null,
                os: null,
                dataEmit: null,
                dateVenc: null,
                valorNota: null,
                pis: null,
                confins: null,
                csll: null,
                ir: null,
                inss: null,
                iss: null,
                aliIss: null,
                valueIss: null,
                tributos: null,
                liquidos: null,
                jobItens: [],
                regimeTributario: null,
                tributacao: null,
                aliquota: null
            },
            nfItens: [],
            romaneios: [],
            fornecedores: [],
            allFornecedores: [],
            clientes: [],
            optionTypeNf: ['Nota Fiscal', 
                'Nota Fiscal Mãe', 
                'Nota Fiscal de Remessa Venda',
                'Nota Fiscal de Serviço'
            ],
            money: {
                locale: "pt-BR",
                decimal: ',',
                thousands: '.',
                prefix: '',
                precision: 2,
                masked: false
            },
            headers: [
                { text: 'Tipo de Nota Fiscal', value: 'tipoNotaFiscal' },
                { text: 'Status', value: 'statusNf' },
                { text: 'Chave de Acesso', value: 'chaveAcesso' },
                { text: 'Valor', value: 'valueNf' },
            ],
            searchNotaChaveAcesso: '',
            loadingProjects: false,
            loadingFornecedores: false,
            loadingClientes: false,
            loadingSearchNota: false,
            lastSearchNotaChaveAcesso: ''
        }
    },
    methods: {
        normalizeComparison(value) {
            return String(value || '')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/[_-]+/g, ' ')
                .replace(/\s+/g, ' ')
                .trim()
                .toUpperCase()
        },

        async getJob(clienteId, options = {}){
            const { usarRegraAberturaOs = false } = options
            this.loadingProjects = true
            let response
            
            if(!clienteId){
                response = await Vue.prototype.$http.get(`/Entity/Project`, {
                    params: {
                        page: 1,
                        limit: 9999
                    }
                });
            } else {
                response = await Vue.prototype.$http.get(`/Entity/Project/search-fields`, {
                    params: {
                        page: 1,
                        limit: 9999,
                        searchFields: 'cliente',
                        value: clienteId
                    }
                });
            }

            const projects = response?.data?.data?.data || []

            if (usarRegraAberturaOs) {
                const jobsEmExecucao = projects.filter((job = {}) => {
                    const status = this.normalizeComparison(job?.status || job?.situacao)
                    return status === 'EM EXECUCAO'
                })

                this.projects = jobsEmExecucao.length > 0 ? jobsEmExecucao : projects
            } else {
                this.projects = projects
            }

            this.loadingProjects = false
        },

        async getClientes(id){
            this.loadingClientes = true
            const response = await Vue.prototype.$http.get(`/Entity/Cliente`, {
                params: {
                    page: 1,
                    limit: 9999,
                    ids: id
                }
            });

            this.clientes = response.data.data.data
            this.loadingClientes = false
            return this.clientes[0]
        },

        async getFornecedores(id){
            this.loadingFornecedores = true
            const response = await Vue.prototype.$http.get(`/Entity/Fornecedor`, {
                params: {
                    page: 1,
                    limit: 9999,
                    ids: id
                }
            });

            this.fornecedores = response.data.data.data
            this.allFornecedores = response.data.data.data
            this.loadingFornecedores = false
            return this.fornecedores
        },


        async getRomaneios(jobId){
            const response = await Vue.prototype.$http.post('/View/run', {
                "params": [ { dataType: "string", name: "jobId", value: jobId } ],
                "viewId": "1baf1963-3349-4644-b65f-795c33f45c1a",
                "page": 1,
                "limit": 3000000

            })

            const romaneiosView = response?.data?.data?.data || []
            const ids = [...new Set(romaneiosView
                .map((romaneio) => romaneio?._id || romaneio?.id)
                .filter(Boolean))]

            if (!ids.length) return romaneiosView

            const responseEntidades = await Vue.prototype.$http.get('/Entity/Romaneio/search-fields', {
                params: {
                    ids: ids.join(','),
                    page: 1,
                    limit: ids.length
                }
            })
            const entidades = responseEntidades?.data?.data?.data || []
            const entidadesPorId = new Map(entidades.map((romaneio) => [
                String(romaneio?._id || romaneio?.id),
                romaneio
            ]))

            return romaneiosView.map((romaneio) => ({
                ...romaneio,
                fisDocEmiId: entidadesPorId.get(String(romaneio?._id || romaneio?.id))?.fisDocEmiId
                    || romaneio?.fisDocEmiId
                    || undefined
            }))
        },

        async validarRomaneiosDisponiveis(romaneios = []) {
            const ids = [...new Set((romaneios || [])
                .map((romaneio) => romaneio?._id || romaneio?.id || romaneio)
                .filter(Boolean))]

            if (!ids.length) return true

            const response = await Vue.prototype.$http.get('/Entity/Romaneio/search-fields', {
                params: {
                    ids: ids.join(','),
                    page: 1,
                    limit: ids.length
                }
            })
            const romaneiosAtuais = response?.data?.data?.data || []
            const indisponiveis = romaneiosAtuais.filter((romaneio) => !!romaneio?.fisDocEmiId)

            if (!indisponiveis.length) return true

            const codigos = indisponiveis.map((romaneio) => romaneio?.codigo || romaneio?._id || romaneio?.id).join(', ')
            this.$notfy.warning(`Não foi possível salvar. O(s) romaneio(s) ${codigos} já possui(em) nota fiscal emitida.`)
            return false
        },

        handleNfItens(e){
            this.nfItens = e
        },


        async slectedJob(value){
            if(!this.emitNotaFiscal.notaFiscalDeRemessa && this.emitNotaFiscal.typeNf == 'Nota Fiscal'){
                this.emitNotaFiscal.destinatario = await this.getClientes(value.cliente)
            } else {
                console.log('JOB >>> ', this.romaneios)
                //this.emitNotaFiscal.destinatario = await this.getFornecedores(value.fornecedor)
            }

            // this.emitNotaFiscal.valorNf = value.valorJob * 100
        },

        async fornecedorSelected(value){
            if(this.romaneios.length == 0) this.romaneios = await this.getRomaneios(this.notaFiscal.job?.id || this.notaFiscal.job)

            // console.log('romaneios >>> ', this.romaneios, value.id)
            this.romaneios = this.romaneios?.filter((rm) => rm.fornecedor == value.id) || []
        },

        async selectedCliente(value){
            if(this.emitNotaFiscal.typeNf == 'Nota Fiscal de Serviço'){
                this.emitNotaFiscal.destinatario = value
            }
        },

        handleParcelas(e){
            this.parcelas = e
        },

        handleNotaFiscal(e){
            this.notaFiscal = e
        },

        handleNotaFiscalServico(e){
            this.objeNotaServico = e

            if(e?.jobItens?.length > 0){
                this.emitNotaFiscal.valorNf = 0 
                e?.jobItens?.map((item) => {
                    this.emitNotaFiscal.valorNf += item.precoTotal
                })
            }

        },

        formatMoeda(valor) {
            return valor.toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },

        formatCurrencyValueNf(item = {}) {
            const valor = Number(item?.valueNf ?? 0) || 0
            return valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
        },

        parseMoeda(valor) {
            if (!valor) return 0;

            valor = valor.toString().trim();

            // Se vier nesse formato estranho: 395.039.30
            // pega os últimos 2 dígitos como centavos
            if (/^\d{1,3}(\.\d{3})*\.\d{2}$/.test(valor)) {
                // remove pontos
                valor = valor.replace(/\./g, '');
                // insere vírgula antes dos 2 últimos dígitos
                valor = valor.slice(0, -2) + ',' + valor.slice(-2);
            }

            return parseFloat(
                valor.replace(/\./g, '')   // remove milhar
                    .replace(',', '.')    // vírgula -> ponto decimal
            ) || 0;
        },

        toIntegerInput(value) {
            if (value == null || value === '') return 0;
            if (typeof value === 'number') return Number.isFinite(value) ? value : 0;

            return Number(
                String(value)
                    .replace(/\./g, '')
                    .replace(/,/g, '')
            ) || 0;
        },

        toStringInput(value) {
            if (value == null) return '';
            return String(value);
        },

        updateSum(sum){
            this.emitNotaFiscal.valorNf = Math.round(this.parseMoeda(sum))
            this.updtaeSum += 1
        },


        resetValues(){
            this.notaFiscal = {
                filial: '',
                job: '',
                ncm: '',
                romaneio: [],
                cest: '',
                icms: '',
                baseIcms: '',
                naturezaOp: '',
                cfop: '',
                cnpj: '',
                itens: [],
                uf: '',
                email: '',
                bairro: '',
                numero: '',
                logradouro: '',
                cidade: '',
                cep: '',
                condPag: '',
                codigoCidade: '',
                transportadora: '',
                codigoBeneficioFiscal: ''
            }
        },

        validate() {
            const formPrincipalValido = this.$refs.formPrincipal?.validate() ?? false;

            const formInternoValido =
            this.$refs.nfComponent?.$refs.formInterno?.validate?.() ?? true;

            if (formPrincipalValido && formInternoValido) {
                return true
            } else {
                return false
            }
        },

        async getParcela(parcelas){

            if(parcelas?.length > 0){
                const response = await Vue.prototype.$http.get('/Entity/FisPreDocEmiFin/search-fields', {
                    params: {
                        ids: parcelas.map((p) => p).join(','),
                        sortField: 'parcelaSequencia',
                        
                    }
                })

                this.parcelas = response.data.data.data.map((p) => {
                    return {
                        id: p.id,
                        numParcela: p.parcelaSequencia, 
                        vencimento: moment(p.dtPag).format('YYYY-MM-DD'), 
                        vrlParcela: p.vlr
                    }
                })
            }
        },

        async getAutoIncFisPreDoc(){
            const response = await this.fisPreDocEmi.autoInc("FisPreDocEmi", "codigo", "######")
            return response.data
        },

        async getItemNf(id, options = {}){
            const { duplicar = false } = options
            const response = await Vue.prototype.$http.post(`/View/run`,
                {
                    "params": [
                        { dataType: "string", name: "id", value: id },
                    ],
                    "viewId": "2a39c593-02d0-46d4-be8c-6dc43dc18c9a",
                    "page": 1,
                    "limit": 1
                }
            );

            const value = response.data.data.data[0]


            if(value){

                if(value.notaFiscal[0]?.parcelas) await this.getParcela(value.notaFiscal[0]?.parcelas)

                if(value.notaFiscalServico[0]?.parcelas) await this.getParcela(value.notaFiscalServico[0]?.parcelas)

                this.emitNotaFiscal = {
                    destinatario: !value.notaFiscalDeRemessa ? value.destinatario : value.destinatarioFornecedor,
                    statusNf: duplicar ? 'Pendente' : value.statusNf,
                    valorNf: Number(value.valueNf) * 100 || 0,
                    typeNf: value.tipoNotaFiscal.replaceAll("_", " "),
                    notaFiscalDeRemessa: value.notaFiscalDeRemessa,
                    id: duplicar ? undefined : value._id
                }


                // console.log('TESTE >>> ', value.valueNf / 100, this.emitNotaFiscal.valorNf)

                if(value.notaFiscal[0]?._id){

                    const response = await Vue.prototype.$http.get('/Entity/Project/' + value.notaFiscal[0].job)
                    const job = response.data.data
                    await this.slectedJob(job)

                    let romaneios = await this.getRomaneios(job?.id || job)
                    romaneios.filter((romaneio) =>  value.notaFiscal[0].romaneio.includes(romaneio._id))

                    // console.log('romaneios >>> ', romaneios.filter((romaneio) =>  value.notaFiscal[0].romaneio.includes(romaneio._id)))

                    this.notaFiscal = {
                        codigo: duplicar ? '' : value.notaFiscal[0].codigo,
                        id: duplicar ? undefined : value.notaFiscal[0]._id,
                        filial: value.notaFiscal[0].filial,
                        job: job,
                        romaneio: romaneios.filter((romaneio) =>  value.notaFiscal[0].romaneio.includes(romaneio._id)),
                        //cest: value.notaFiscal[0].cest,
                        icms: value.notaFiscal[0].aliIcms,
                        baseIcms: value.notaFiscal[0].baseIcms,
                        naturezaOp: value.notaFiscal[0].naturezaOperacao,
                        defFiscais: value.notaFiscal[0].defFiscais || undefined,
                        //destinatario: value.notaFiscal[0].destinatario,
                        cnpj: value.notaFiscal[0].cnpj,
                        itens: value.notaFiscal[0].itens,
                        uf: value.notaFiscal[0].uf,
                        email: value.notaFiscal[0].email,
                        bairro: value.notaFiscal[0].destinatarioBairro,
                        numero: value.notaFiscal[0].destinatarioNumero,
                        logradouro: value.notaFiscal[0].destinatarioLogradouro,
                        cidade: value.notaFiscal[0].destinatarioCidade,
                        cep: value.notaFiscal[0].destinatarioCep,
                        condPag: value.notaFiscal[0].condicaoPagamento,
                        codigoCidade: value.notaFiscal[0].codigoCidade,
                        notaFiscalMae: value.notaFiscal[0]?.notaFiscalMae || undefined,
                        addRetirada: value.notaFiscal[0]?.addRetirada,
                        transportadora: value.notaFiscal[0]?.transportadora,
                        dataSaida: moment(value.notaFiscal[0]?.dataSaida).format('YYYY-MM-DD'),
                        quantidade: value.notaFiscal[0].volumeQuantidade,
                        especie: value.notaFiscal[0].especie,
                        marca: value.notaFiscal[0].marca,
                        numeracao: value.notaFiscal[0].volumeNumeracao,
                        pesoBruto: value.notaFiscal[0].pesoBruto,
                        pesoLiquido: value.notaFiscal[0].pesoLiquido,
                        valorFrete:  value.notaFiscal[0].valorFrete,
                        valorSeguro: value.notaFiscal[0].valorSeguro,
                        valorDesconto: value.notaFiscal[0].valorDesconto,
                        valorOutros: value.notaFiscal[0].valorOutros,
                        ncm: value.notaFiscal[0].ncm,
                        cest: value.notaFiscal[0].cest,
                        cfop: value.notaFiscal[0].cfop,
                        operacaoFiscal: value.notaFiscal[0].fisOper,
                        informacaoAdd: value.notaFiscal[0].informacaoAdd,
                        meioPagamento: value.notaFiscal[0]?.meioPagamento?.replaceAll('_', ' ') || '',
                        codigoBeneficioFiscal: value.notaFiscal[0]?.codigoBeneficioFiscal || ''
                    }

                    // console.log('Nota Fiscal >>> ', this.notaFiscal)

                } else if(value.notaFiscalServico[0]?._id){

                    console.log('NF SERVICE >>> ', value.notaFiscalServico[0])

                    this.objeNotaServico = {
                        id: duplicar ? undefined : value.notaFiscalServico[0]?._id,
                        cpfOrCnpjEmitente: value.notaFiscalServico[0].emitenteCpfOrCnpj,
                        razaoSocialNomeEmitente: value.notaFiscalServico[0].emitenteRazaoSocial,
                        cnae: value.notaFiscalServico[0].cnae,
                        aliIss: value.notaFiscalServico[0].aliIss,
                        codMunicipio: value.notaFiscalServico[0].codMunicipio,
                        inscricaoMinucipal: value.notaFiscalServico[0].emitenteIm,
                        localEmissao: value.notaFiscalServico[0].emitenteLocalEmissao,
                        emitenteLogradouro: value.notaFiscalServico[0].emitenteLogradouro,
                        emitenteBairro: value.notaFiscalServico[0].emitenteBairro,
                        emitenteTipoEnquadramento: value.notaFiscalServico[0].enqServico,
                        cpfOrCnpjTomador: value.notaFiscalServico[0].tomadorCpfOrCnpj,
                        razaoSocialNomeTomador: value.notaFiscalServico[0].tomadorRazaoSocial,
                        inscricaoMinucipalTomador: value.notaFiscalServico[0].inscricaoMinucipalTomador,
                        endereco: value.notaFiscalServico[0].tomadorEndereco,
                        localRecebimento: value.notaFiscalServico[0].tomadorLocalRecebido,
                        descricao: value.notaFiscalServico[0].descricao,
                        emitenteCodCidade: value.notaFiscalServico[0].emitenteCodCidade,
                        baseCalculo: value.notaFiscalServico[0].vrlBaseCalc,
                        iss: value.notaFiscalServico[0].vlrISS,
                        ir: value.notaFiscalServico[0].vlrIR,
                        pis: value.notaFiscalServico[0].vlrPIS,
                        confins: value.notaFiscalServico[0].vlrCOFINS,
                        csll: value.notaFiscalServico[0].vlrSCLL,
                        dateVenc: value.notaFiscalServico[0].dataVenc,
                        liquidos: value.notaFiscalServico[0].vlrLiquido,
                        job: value.notaFiscalServico[0].job,
                        tipoServico: value.notaFiscalServico[0].tipoServico,
                        tomadorCep: value.notaFiscalServico[0].tomadorCep,
                        tomadorEmail: value.notaFiscalServico[0].tomadorEmail,
                        tomadorNumero: value.notaFiscalServico[0].tomadorNumero,
                        tomadorComplemento: value.notaFiscalServico[0].tomadorComplemento,
                        tomadorUf: value.notaFiscalServico[0].tomadorUf,
                        codigoCidade: value.notaFiscalServico[0].codigoCidade,
                        jobItens: value.notaFiscalServico[0].jobItens,
                        jobItensList: value.notaFiscalServico[0].jobItensList,
                        regimeTributario: value.notaFiscalServico[0]?.regimeTributario || undefined,
                        enquadramento: value.notaFiscalServico[0].enquadramentoServico || undefined,
                        tributacaoMunicipal: { 
                            ...value.notaFiscalServico[0]?.tributacao[0],
                            id: value.notaFiscalServico[0]?.tributacao[0]?._id
                        },
                        aliquota: value.notaFiscalServico[0].aliquota,
                        imposto: Number(value.notaFiscalServico[0].imposto) * 100,
                        dedutivel: Number(value.notaFiscalServico[0].dedutivel) * 100,
                    }
                } else {
                    this.objeNotaServico = {}
                    this.notaFiscal = {}
                }

                this.componentKey += 1
                this.updtaeSum += 1

            } else {
                this.objeNotaServico = {}
                this.notaFiscal = {}
                this.emitNotaFiscal = {}
            }
        },

        async createParcela(){
            const toNumberParcela = (valor = '') => Number(String(valor || '').replace(/\./g, '').replace(',', '.'))

            const normalizeParcelaForInsert = (parcela = {}) => ({
                parcelaSequencia: parcela.parcelaSequencia ?? parcela.numParcela,
                dtPag: parcela.dtPag ?? parcela.vencimento,
                vlr: toNumberParcela(parcela.vlr ?? parcela.vrlParcela)
            })

            if(this.parcelas.length > 0){
                const parcelasParaCriar = this.isDuplicating
                    ? this.parcelas.map((p) => normalizeParcelaForInsert(p))
                    : this.parcelas.filter(p => !p.id)
                    .map((p) => normalizeParcelaForInsert(p));

                const parcelasParaAtualizar = this.isDuplicating
                    ? []
                    : this.parcelas.filter(p => !!p.id)
                    .map(p => ({
                        id: p.id,
                        ...normalizeParcelaForInsert(p)
                    }));

                let responseCriacao = { data: { data: [] } };
                let responseAtualizacao = { data: { data: [] } };

                if (parcelasParaCriar.length > 0) {
                    const payloadParcelasCriar = parcelasParaCriar.map((parcela) => normalizeParcelaForInsert(parcela))

                    responseCriacao = await Vue.prototype.$http.post(
                        '/Entity/insertMany/FisPreDocEmiFin',
                        payloadParcelasCriar
                    );
                }

                if (parcelasParaAtualizar.length > 0) {
                    responseAtualizacao = await Vue.prototype.$http.put(
                        '/Entity/updateMany/FisPreDocEmiFin',
                        parcelasParaAtualizar
                    );
                }

                return [
                    ...responseCriacao.data.data.map(item => item.id),
                    ...responseAtualizacao.data.data.map(item => item.id)
                ];
            }

            const response = await Vue.prototype.$http.post(
                '/Entity/FisPreDocEmiFin',
                {
                    parcelaSequencia: '1',
                    dtPag: new Date().toISOString().split("T")[0] + "T03:00:00Z",
                    vlr: Number(this.emitNotaFiscal.valorNf.replace(/\./g, '').replace(',', '.'))
                }
            )

            return [
                ...response.data.data
            ]

        },

        async createItensPreNota(){
            console.log('nfItens >>> ', this.nfItens)

            const sanitizeItemPayload = (item = {}) => {
                const {
                    id,
                    _id,
                    createAt,
                    updateAt,
                    updatedAt,
                    createBy,
                    updateBy,
                    deleteAt,
                    deleteBy,
                    isDeleted,
                    ...payload
                } = item || {}

                return payload
            }

            const itensBase = this.isDuplicating
                ? this.nfItens.map((nf) => sanitizeItemPayload(nf))
                : this.nfItens

            const itensCriar = itensBase
                .filter(nf => !nf.id)
                .map(nf => ({
                    ...sanitizeItemPayload(nf),
                    ipiCompoeBaseCalculo: Boolean(nf.ipiCompoeBaseCalculo),
                    freteCompoeBaseCalculo: Boolean(nf.freteCompoeBaseCalculo),
                    // item: nf.item || undefined,
                    // jobItem: undefined,
                    quantidade: String(nf.quantidade),
                    icmsPercentual: this.toStringInput(nf.icmsPercentual),
                    sequencia: Number(nf.sequencia),
                    aliquotaUf: nf.aliquotaUf != null ? this.toStringInput(nf.aliquotaUf) : '',
                    valorUf: this.toIntegerInput(nf.valorUf),
                    cstIbsCbs: nf.cstIbsCbs || undefined,
                    classificacaoIbsCbs: nf.classificacaoIbsCbs || undefined,
                    percentualBaseCalculoIbsCbs: nf.percentualBaseCalculoIbsCbs,  // ? this.toStringInput(nf.percentualBaseCalculoIbsCbs).replaceAll(/\./g, '').replaceAll(',', '') : '',
                    valorBaseCalculoIbsCbs: this.toIntegerInput(nf.valorBaseCalculoIbsCbs),
                    aliquotaCbs: this.toStringInput(nf.aliquotaCbs),
                    valorCbs: this.toIntegerInput(nf.valorCbs),
                    ipiPercentual: this.toStringInput(nf.ipiPercentual),
                    ipiBaseCalculo: this.toIntegerInput(nf.ipiBaseCalculo),
                    ipiValor: this.toIntegerInput(nf.ipiValor),
                    pisBaseCalculo: this.toIntegerInput(nf.pisBaseCalculo),
                    cofinsBaseCalculo: this.toIntegerInput(nf.cofinsBaseCalculo),
                    resultBaseCalcICMS: this.toIntegerInput(nf.resultBaseCalcICMS),
                    icmsBaseCalculo: this.toIntegerInput(nf.icmsBaseCalculo),
                    icmsValor: this.toIntegerInput(nf.icmsValor),
                    cofinsValor: this.toIntegerInput(nf.cofinsValor),
                    pisValor: this.toIntegerInput(nf.pisValor),
                    valorUnitario: this.toIntegerInput(nf.valorUnitario),
                    valorTotal: this.toIntegerInput(nf.valorTotal),
                    valorFrete: this.toIntegerInput(nf.valorFrete),
                    valorSeguro: this.toIntegerInput(nf.valorSeguro),
                    valorDesconto: this.toIntegerInput(nf.valorDesconto),
                    valorOutros: this.toIntegerInput(nf.valorOutros), 
                }));


            const itensAtualizar = this.isDuplicating
                ? []
                : this.nfItens
                .filter(nf => !!nf.id)
                .map(nf => ({
                    id: nf.id,
                    ...sanitizeItemPayload(nf),
                    ipiCompoeBaseCalculo: Boolean(nf.ipiCompoeBaseCalculo),
                    freteCompoeBaseCalculo: Boolean(nf.freteCompoeBaseCalculo),
                    // item: nf.item || undefined,
                    // jobItem: undefined,
                    quantidade: String(nf.quantidade),
                    aliquotaUf: nf.aliquotaUf != null ? this.toStringInput(nf.aliquotaUf) : '',
                    valorUf: this.toIntegerInput(nf.valorUf),
                    aliquotaCbs: this.toStringInput(nf.aliquotaCbs),
                    valorCbs: this.toIntegerInput(nf.valorCbs),
                    cstIbsCbs: nf.cstIbsCbs || undefined,
                    classificacaoIbsCbs: nf.classificacaoIbsCbs || undefined,
                    percentualBaseCalculoIbsCbs: nf.percentualBaseCalculoIbsCbs, //nf.percentualBaseCalculoIbsCbs ? this.toStringInput(nf.percentualBaseCalculoIbsCbs).replaceAll(/\./g, '').replaceAll(',', '') : '',
                    valorBaseCalculoIbsCbs: this.toIntegerInput(nf.valorBaseCalculoIbsCbs),
                    pedidoDeCompra: nf.pedidoDeCompra || undefined,
                    ipiPercentual: this.toStringInput(nf.ipiPercentual),
                    ipiBaseCalculo: this.toIntegerInput(nf.ipiBaseCalculo),
                    ipiValor: this.toIntegerInput(nf.ipiValor),
                    pisBaseCalculo: this.toIntegerInput(nf.pisBaseCalculo),
                    cofinsBaseCalculo: this.toIntegerInput(nf.cofinsBaseCalculo),
                    resultBaseCalcICMS: this.toIntegerInput(nf.resultBaseCalcICMS),
                    icmsPercentual: this.toStringInput(nf.icmsPercentual),
                    icmsBaseCalculo: this.toIntegerInput(nf.icmsBaseCalculo),
                    icmsValor: this.toIntegerInput(nf.icmsValor),
                    cofinsValor: this.toIntegerInput(nf.cofinsValor),
                    pisValor: this.toIntegerInput(nf.pisValor),
                    valorUnitario: this.toIntegerInput(nf.valorUnitario),
                    valorTotal: this.toIntegerInput(nf.valorTotal),
                    valorFrete: this.toIntegerInput(nf.valorFrete),
                    valorSeguro: this.toIntegerInput(nf.valorSeguro),
                    valorDesconto: this.toIntegerInput(nf.valorDesconto),
                    valorOutros: this.toIntegerInput(nf.valorOutros), 
                }));

                console.log('itensAtualizar >>> ', itensAtualizar)

            let responseCriacao = { data: { data: [] } };
            let responseAtualizacao = { data: { data: [] } };

            if (itensCriar.length > 0) {
                responseCriacao = await Vue.prototype.$http.post(
                    '/Entity/insertMany/FisPreDocEmiItem',
                    itensCriar
                );
            }

            if (itensAtualizar.length > 0) {
                responseAtualizacao = await Vue.prototype.$http.put(
                    '/Entity/updateMany/FisPreDocEmiItem',
                    itensAtualizar
                );
            }

            return [
                ...responseCriacao.data.data.map(item => item.id),
                ...responseAtualizacao.data.data.map(item => item.id)
            ];

        },

        async createEmitNf(){

            const isValidate = this.validate()

            if(!isValidate){
                this.$notfy.error("Formulário Não preenchido corretamente.")
                return
            }

            const filial = localStorage.getItem('CompanySiteIdSelected')

            let fispreDocEmi
            let fisDocService

            // console.log('handle nf ', this.emitNotaFiscal, this.notaFiscal)

            if(this.emitNotaFiscal.typeNf != 'Nota Fiscal de Serviço'){

                if(this.nfItens?.length == 0) {
                    this.$notfy.error("Erro, Precisa adicionar os itens da nota.")
                    return
                }

                if (!await this.validarRomaneiosDisponiveis(this.notaFiscal?.romaneio)) return

                let parcelas = []
                if((this.notaFiscal.condPag == 'á prazo') && !this.isCfopsNfMae.includes(this.notaFiscal.cfop)){
                    parcelas = await this.createParcela()
                } 
                
                /*else if(this.parcelas.length > 0 && this.notaFiscal.condPag == 'á vista'){
                    // Remove as parcelas
                    await Promise.all(
                        this.parcelas.map(async (p) => {
                            if(p.id){
                                await Vue.prototype.$http.delete(`/Entity/FisPreDocEmiFin?id=${p.id}`)
                            }
                        })
                    )
                }*/

                let nfItens = []
                if(this.nfItens.length > 0){
                    nfItens = await this.createItensPreNota()
                }

                console.log('ROMANEIO >>> ', this.notaFiscal?.romaneio[0])
                

                const dataEmissao = new Date().toISOString().split("T")[0] + "T03:00:00Z"

                const response = await this.fisPreDocEmi.insertOrUpdate({
                    codigo: this.notaFiscal.codigo ? this.notaFiscal.codigo : await this.getAutoIncFisPreDoc(),
                    id: this.notaFiscal.id ? this.notaFiscal.id : undefined,
                    filial: this.notaFiscal.id ? this.notaFiscal.filial : filial,
                    job: this.notaFiscal?.job?.id || undefined,
                    romaneio: this.notaFiscal?.romaneio?.map((r) => {
                        return r?._id || r
                    }) || undefined,
                    transporteTipo: this.notaFiscal?.romaneio[0]?.transporteTipo || undefined,
                    cliente: this.emitNotaFiscal.destinatario.id,
                    cnpj: this.notaFiscal.cnpj,
                    //cfop: undefined, // vai vim do schema FisOper
                    //condicaoParcelas: '', //Vai vim do schema CondP
                    statusEmissao: 'DESENVOLVENDO',
                    dataEmissao: dataEmissao,
                    naturezaOperacao: this.notaFiscal.naturezaOp,
                    defFiscais: this.notaFiscal.defFiscais || undefined,
                    condicaoPagamento: this.notaFiscal.condPag,
                    destinatarioCep: this.notaFiscal.cep,
                    destinatarioCidade: this.notaFiscal.cidade,
                    destinatarioLogradouro: this.notaFiscal.logradouro,
                    destinatarioNumero: this.notaFiscal.numero,
                    destinatarioBairro: this.notaFiscal.bairro,
                    codigoCidade: this.notaFiscal.codigoCidade,
                    uf: this.notaFiscal.uf,
                    email: this.notaFiscal.email,
                    notaFiscalMae: this.notaFiscal?.notaFiscalMae || undefined,
                    itens: nfItens || [],
                    parcelas: (this.notaFiscal.condPag == 'á prazo') ? parcelas : [],
                    addRetirada: this.notaFiscal.addRetirada,
                    dataSaida: dataEmissao,
                    fornecedor: this.notaFiscal?.job?.fornecedor,
                    transportadora: this.notaFiscal?.transportadora,
                    volumeQuantidade: this.notaFiscal.quantidade ? Number(this.notaFiscal.quantidade) : undefined,
                    especie: this.notaFiscal.especie,
                    marca: this.notaFiscal.marca,
                    volumeNumeracao: this.notaFiscal?.numeracao || undefined,
                    pesoBruto: this.notaFiscal?.pesoBruto || undefined,
                    pesoLiquido: this.notaFiscal.pesoLiquido || undefined,
                    valorFrete: this.notaFiscal.valorFrete ? Number(this.notaFiscal.valorFrete?.replace(/\./g, '')?.replace(',', '.') || 0) : 0,
                    valorSeguro: this.notaFiscal.valorSeguro ? Number(this.notaFiscal.valorSeguro?.replace(/\./g, '')?.replace(',', '.') || 0) : 0,
                    valorDesconto: this.notaFiscal.valorDesconto ? Number(this.notaFiscal.valorDesconto?.replace(/\./g, '')?.replace(',', '.') || 0) : 0,
                    valorOutros: this.notaFiscal.valorOutros ? Number(this.notaFiscal.valorOutros?.replace(/\./g, '')?.replace(',', '.') || 0) : 0,
                    //valorBaseDeCalculo: 
                    ncm: this.notaFiscal.ncm || undefined,
                    cest: this.notaFiscal.cest || undefined,
                    cfop: this.notaFiscal.cfop,
                    fisOper: this.notaFiscal?.operacaoFiscal || undefined,
                    informacaoAdd: this.notaFiscal.informacaoAdd,
                    meioPagamento: this.notaFiscal.meioPagamento,
                    codigoBeneficioFiscal: this.emitNotaFiscal.notaFiscalDeRemessa ? (this.notaFiscal.codigoBeneficioFiscal || undefined) : undefined
                })

                if(!response?.data?.data?.id){
                    this.$notfy.error("Erro ao salvar a nota fiscal. Verifique os dados e tente novamente.")
                    return
                }

                fispreDocEmi = response.data.data.id

            } else {

                // BUGFIX (a pedido do usuário): antes disto, se o Valor Líquido (objeNotaServico.liquidos,
                // campo readonly calculado a partir dos Itens do Job/Base de Cálculo) estivesse zerado ou
                // vazio, a tela seguia em frente e tentava salvar a Nota de Serviço e a parcela mesmo assim
                // — no melhor caso emitindo uma nota com valor 0, no pior estourando erro só lá na frente.
                // Agora valida ANTES de qualquer chamada e avisa o usuário com uma mensagem clara.
                const valorLiquidoServico = Number(
                    String(this.objeNotaServico?.liquidos || '0').replace(/\./g, '').replace(',', '.')
                ) || 0
                if (!(valorLiquidoServico > 0)) {
                    this.$notfy.error("Valor Líquido da Nota de Serviço não pode ser zero. Selecione os Itens do Job (ou preencha a Base de Cálculo) antes de emitir.")
                    return
                }

                let parcelas = []
                if(this.parcelas.length > 0){
                    parcelas = await this.createParcela()
                }

                // BUGFIX: log de depuração residual removido - além de não ser mais necessário, ele
                // chamava ".replace()" direto em objeNotaServico.confins sem converter pra String antes;
                // como esse campo vem como Number cru ao editar uma nota de Serviço já existente (sem
                // recalcular via calcImpostos()), isso estourava TypeError AQUI MESMO, abortando o save
                // inteiro antes de qualquer chamada à API (nem o FisDocService nem o EmissaoNotasFiscais
                // chegavam a ser salvos).

                const response = await this.fisDocEntity.insertOrUpdate({
                    id: this.objeNotaServico.id ? this.objeNotaServico.id : undefined,
                    emitenteCpfOrCnpj: this.objeNotaServico.cpfOrCnpjEmitente,
                    emitenteRazaoSocial: this.objeNotaServico.razaoSocialNomeEmitente,
                    cnae: this.objeNotaServico?.cnae || undefined,
                    emitenteIm: this.objeNotaServico.inscricaoMinucipal,
                    emitenteTipoEnquadramento: this.objeNotaServico.enqServico,
                    emitenteLocalEmissao: this.objeNotaServico.localEmissao,
                    emitenteLogradouro: this.objeNotaServico.emitenteLogradouro,
                    emitenteBairro: this.objeNotaServico.emitenteBairro,
                    tomadorCpfOrCnpj: this.objeNotaServico.cpfOrCnpjTomador,
                    tomadorRazaoSocial: this.objeNotaServico.razaoSocialNomeTomador,
                    tomadorIm: this.objeNotaServico.tomadorIm,
                    tomadorEndereco: this.objeNotaServico.endereco,
                    tomadorLocalRecebido: this.objeNotaServico.localRecebimento,
                    tomadorUf: this.objeNotaServico.tomadorUf,
                    tomadorNumero: this.objeNotaServico.tomadorNumero,
                    tomadorCep: this.objeNotaServico.tomadorCep,
                    tomadorEmail: this.objeNotaServico.tomadorEmail,
                    descricao: this.objeNotaServico.descricao,
                    codigoCidade: this.objeNotaServico.codigoCidade,
                    jobItens: this.objeNotaServico.jobItens.map((item) => item.id),
                    emitenteCodCidade: this.objeNotaServico.emitenteCodCidade,
                    // BUGFIX: campos calculados (baseCalculo/ir/pis/confins/csll/inss/liquidos) chegam como
                    // NUMBER cru (não string mascarada v-money) logo após abrir uma nota de Serviço já
                    // existente para editar (ver bloco de carregarNotaExistente acima, que atribui
                    // vrlBaseCalc/vlrIR/vlrPIS/... diretamente do backend). ".replace()" não existe em
                    // Number, então salvar sem antes disparar calcImpostos() (ex.: sem tocar no Job/Valor/
                    // Alíquota) estourava TypeError aqui DEPOIS do FisDocService já ter sido salvo (linha
                    // acima) mas ANTES do update final em EmissaoNotasFiscais (valueNf/statusNf) — deixando
                    // o grid com "Valor com Impostos" zerado/desatualizado mesmo com a Pré-Visualização
                    // (que relê o FisDocService direto) mostrando o valor certo. Envolver em String(...)
                    // torna o parse seguro tanto para Number cru quanto para a string mascarada normal.
                    vrlBaseCalc: Number(String(this.objeNotaServico?.baseCalculo ?? 0).replace(/\./g, '').replace(',', '.')) || undefined,
                    //vlrISS: Number(String(this.objeNotaServico?.iss ?? 0).replace(/\./g, '').replace(',', '.')) || undefined,
                    vlrIR: Number(String(this.objeNotaServico?.ir ?? 0).replace(/\./g, '').replace(',', '.')) || undefined,
                    vlrPIS: Number(String(this.objeNotaServico?.pis ?? 0).replace(/\./g, '').replace(',', '.')) || undefined,
                    vlrCOFINS: Number(String(this.objeNotaServico?.confins ?? 0).replace(/\./g, '').replace(',', '.')) || undefined,
                    vlrSCLL: Number(String(this.objeNotaServico?.csll ?? 0).replace(/\./g, '').replace(',', '.')) || undefined,
                    vrlINSS: Number(String(this.objeNotaServico?.inss ?? 0).replace(/\./g, '').replace(',', '.')) || undefined,
                    imposto: Number(this.objeNotaServico.imposto) || undefined,
                    dedutivel: Number(this.objeNotaServico.dedutivel) || undefined,
                    // BUGFIX: 'YYYY-mm-dd' usa 'mm' minúsculo (minutos no moment.js), não o mês. Isso corrompia
                    // a data (ex.: "2026-43-Mo" em vez de "2026-08-31"). Corrigido para 'YYYY-MM-DD'.
                    dataEmissao: moment().format('YYYY-MM-DD'),
                    dataVenc: this.objeNotaServico.dateVenc ? moment(this.objeNotaServico.dateVenc).format('YYYY-MM-DD') : undefined,
                    vlrLiquido: this.objeNotaServico.liquidos ? Number(String(this.objeNotaServico.liquidos ?? 0).replace(/\./g, '').replace(',', '.')) || 0 : 0,
                    regimeTributario: this.objeNotaServico?.regimeTributario || undefined,
                    enquadramentoServico: this.objeNotaServico?.enquadramento || undefined,
                    tributacaoMunicipal: this.objeNotaServico?.tributacaoMunicipal?.id || undefined,
                    aliquota: this.objeNotaServico.aliquota || 0,
                    job: this.objeNotaServico.job?.id || this.objeNotaServico.job,
                    tipoServico: this.objeNotaServico.tipoServico,
                    parcelas: parcelas
                })

                if(!response?.data?.data?.id){
                    this.$notfy.error("Erro ao salvar a nota fiscal de serviço. Verifique os dados e tente novamente.")
                    return
                }

                fisDocService = response.data.data.id

                // BUGFIX: a lógica abaixo foi replicada da action "AfterSave Nota de Serviço" (hook
                // server-side, disparado automaticamente pelo backend logo após o insert do FisDocService).
                // Esse hook falhava de forma intermitente com 400 "Entity not found by the provided
                // entityId": o backend (EntityController.RunActionForSchema) re-busca por Id o registro
                // recém-inserido pra entregar ao hook, e às vezes essa leitura acontece antes do insert
                // estar visível (race condition), derrubando a emissão inteira mesmo com a nota já salva
                // corretamente. A pedido do usuário, o hook foi removido do schema FisDocService e a mesma
                // lógica passa a rodar aqui no front, logo após o insertOrUpdate, sem depender daquele
                // re-fetch problemático.
                await this.finalizarNotaServico(response.data.data)
            }

            // Nota de serviço resolve o cliente pelo Job; usa esse valor caso o campo Cliente do topo não tenha sido preenchido.
            const destinatarioResolvido = this.emitNotaFiscal.destinatario || this.objeNotaServico?.destinatario

            await this.emissaoDoc.insertOrUpdate({
                ...this.emitNotaFiscal,
                valorNf: undefined,
                typeNf: undefined,
                tipoNotaFiscal: this.emitNotaFiscal.typeNf,
                destinatario: !this.emitNotaFiscal.notaFiscalDeRemessa ? (destinatarioResolvido?.id ? destinatarioResolvido.id : destinatarioResolvido) : undefined,
                destinatarioFornecedor: this.emitNotaFiscal.notaFiscalDeRemessa ? (destinatarioResolvido?.id ? destinatarioResolvido.id : destinatarioResolvido) : undefined,
                statusNf: this.emitNotaFiscal.statusNf,
                notaFiscal: fispreDocEmi,
                notaFiscalServico: fisDocService,
                // BUGFIX: para Nota Fiscal de Serviço, emitNotaFiscal.valorNf nunca é preenchido (só o fluxo
                // de Venda/Remessa, baseado em itens, popula esse campo). Isso mandava valueNf: null pro
                // schema EmissaoNotasFiscais (campo "number"), que rejeitava a validação (400 "#/valueNf")
                // e a nota nunca era vinculada — mesmo com o FisDocService já salvo. O valor líquido correto
                // pra Serviço é objeNotaServico.liquidos, o mesmo já usado acima em vlrLiquido.
                // BUGFIX #2: objeNotaServico.liquidos vem como Number cru (não string mascarada) ao editar
                // uma nota de Serviço já existente (ver bloco de carga acima) - ".replace()" direto num
                // Number estourava TypeError aqui, abortando o save ANTES deste update final em
                // EmissaoNotasFiscais e deixando valueNf com o valor antigo/zerado no grid (mesmo com o
                // FisDocService salvo corretamente - por isso a Pré-Visualização mostrava o valor certo mas
                // o grid não). Envolver em String(...) torna seguro para os dois formatos.
                valueNf: this.emitNotaFiscal.typeNf == 'Nota Fiscal de Serviço'
                    ? Number(String(this.objeNotaServico?.liquidos ?? 0).replace(/\./g, '').replace(',', '.')) || 0
                    : this.emitNotaFiscal?.valorNf / 100,
                id: this.emitNotaFiscal.id ? this.emitNotaFiscal.id : undefined
            })

            this.$router.back()
        },

        // BUGFIX: porte da action de backend "AfterSave Nota de Serviço" (schema FisDocService) pro
        // front, pra não depender mais do hook server-side que causava o 400 intermitente por race
        // condition. Mesma regra de negócio original: gera um lançamento em FinPay por parcela da nota
        // e marca a nota de serviço como "Concluído".
        //
        // Observação (pré-existente, não introduzida por esta correção): os campos "pedido" e
        // "fornecedor" existem no schema FisDocService mas NUNCA são preenchidos por esta tela (ela só
        // cobre o caso de emissão de nota de serviço PARA o cliente do JOB) — então "pedidoDeCompra" e
        // "favorecidoFornecedor" abaixo já saem undefined hoje em produção, igual saíam antes com o
        // hook no backend. Mantive o mesmo comportamento; se o FinPay para Nota de Serviço deveria
        // referenciar o cliente/JOB em vez de um fornecedor/pedido de compra, isso é uma decisão de
        // negócio que precisa ser confirmada antes de mudar.
        async finalizarNotaServico(entity = {}){
            try {
                const parcelasIds = (entity.parcelas || []).map((p) => p?.id || p).filter(Boolean)

                let parcelasResponse = []
                if (parcelasIds.length > 0) {
                    const response = await Vue.prototype.$http.get('/Entity/FisPreDocEmiFin/search-fields', {
                        params: { ids: parcelasIds.join(',') }
                    })
                    parcelasResponse = response?.data?.data?.data || []
                }

                if (parcelasResponse.length > 0) {
                    const payload = parcelasResponse.map((parcela, i) => ({
                        origem: 'Nota de Serviço',
                        status: 'Prevista',
                        pagamentoForma: 'TED',
                        pagamentoTipo: 'Nota Fiscal',
                        pagamentoEvento: 'C/Nota de Serviço',
                        sequencia: i + 1,
                        descricao: 'Pagamento realizado a partir da nota de serviço N°',
                        pedidoDeCompra: entity.pedido,
                        favorecidoFornecedor: entity.fornecedor,
                        filial: 'c511a33d-6b85-4cdf-88af-6a221f0eb46d',
                        dataVencimento: entity.dataVenc,
                        valorOriginal: entity.vlrLiquido,
                        valorDesconto: 0,
                        valorPago: 0,
                        // BUGFIX: a action original usava sempre parcelasResponse[0].vlr dentro do loop,
                        // então toda nota com mais de uma parcela gerava o mesmo "valorRestante" (o da
                        // 1ª parcela) em todos os lançamentos. Corrigido pra usar o valor de cada parcela.
                        valorRestante: parcela.vlr
                    }))

                    await Vue.prototype.$http.post('/Entity/insertMany/FinPay', payload)
                }

                await this.fisDocEntity.insertOrUpdate({
                    ...entity,
                    status: 'Concluído'
                })
            } catch (err) {
                // Não bloqueia a emissão: a nota de serviço já foi salva com sucesso antes desta etapa.
                console.error('Erro ao finalizar nota de serviço (geração de FinPay/status)', err)
                this.$notfy.error('Nota de serviço salva, mas houve um erro ao gerar o(s) lançamento(s) financeiro(s) (FinPay) ou atualizar o status. Verifique manualmente.')
            }
        },

        async searchNotaFisca(){
            const chave = String(this.searchNotaChaveAcesso || '').trim()
            if (!chave || this.loadingSearchNota) return

            // Evita disparo duplicado para a mesma chave enquanto o resultado atual já está em tela.
            if (this.lastSearchNotaChaveAcesso === chave && this.itemsData.length > 0) return

            this.loadingSearchNota = true
            try {
                // PERFORMANCE (11/09/2026): antes buscava a coleção inteira de notas fiscais
                // (limit=100000000) e filtrava a chave de acesso no navegador — o mesmo padrão
                // "buscar tudo" já identificado em getIssuanceInvoices()/carregarMapaJobCodigoPorIds.
                // Trocado por um único filtro direto no servidor (params: chaveAcesso), igual ao
                // padrão que já era usado logo abaixo nesta mesma função (params + limit:1).
                const response = await Vue.prototype.$http.post('/View/run', {
                    params: [
                        { name: 'chaveAcesso', dataType: 'string', value: chave }
                    ],
                    viewId: '2a39c593-02d0-46d4-be8c-6dc43dc18c9a',
                    page: 1,
                    limit: 1
                })

                this.itemsData = response?.data?.data?.data || []
                this.selected = []
                this.lastSearchNotaChaveAcesso = chave
            } finally {
                this.loadingSearchNota = false
            }
        },


    },
    watch: {
        async ['notaFiscal.job'](job){
            if(this.emitNotaFiscal.typeNf !== 'Nota Fiscal de Serviço'){
               this.romaneios = await this.getRomaneios(job?.id || job)

                if(this.emitNotaFiscal.notaFiscalDeRemessa){
                    const fornecedorSelecionadoId = this.emitNotaFiscal.destinatario?.id || this.emitNotaFiscal.destinatario
                    if(this.allFornecedores.length === 0) await this.getFornecedores(undefined)
                    const fornecedorIds = [...new Set(this.romaneios.map((r) => r.fornecedor).filter(Boolean))]
                    const fornecedoresFiltrados = this.allFornecedores.filter((f) => fornecedorIds.includes(f.id))
                    this.fornecedores = fornecedoresFiltrados

                    const fornecedorSelecionado = this.fornecedores.find((f) => String(f.id) === String(fornecedorSelecionadoId))
                    if(fornecedorSelecionado){
                        this.emitNotaFiscal.destinatario = fornecedorSelecionado
                    } else {
                        this.emitNotaFiscal.destinatario = this.fornecedores.length === 1 ? this.fornecedores[0] : null
                    }
                    //let fornecedor = this.romaneios[0]?.romaneiopackinglist[0]?.listaDeEmbarqueItem[0].fornecedor
                }
            }
            
        },

        async selected(value){
            const selecionado = Array.isArray(value) ? value[0] : null

            if(selecionado){
                await this.getClientes(selecionado?.destinatario)

                const notaFiscalSelecionada = Array.isArray(selecionado?.notaFiscal)
                    ? (selecionado.notaFiscal[0] || {})
                    : (selecionado?.notaFiscal || {})

                this.emitNotaFiscal = {
                    destinatario: selecionado?.destinatario,
                    notaFiscalDeRemessa: false,
                    statusNf: 'Pendente',
                    typeNf: 'Nota Fiscal',
                    valorNf: Number(selecionado?.valueNf ?? 0) * 100 || 0,
                    id: undefined
                }


                this.notaFiscal = {
                    codigo: notaFiscalSelecionada?.codigo,
                    filial: notaFiscalSelecionada?.filial,
                    job: notaFiscalSelecionada?.job,
                    romaneio: [],
                    icms: notaFiscalSelecionada?.aliIcms,
                    baseIcms: notaFiscalSelecionada?.baseIcms,
                    defFiscais: notaFiscalSelecionada?.defFiscais || undefined,
                    cnpj: notaFiscalSelecionada?.cnpj,
                    itens: [],
                    uf: notaFiscalSelecionada?.uf,
                    email: notaFiscalSelecionada?.email,
                    bairro: notaFiscalSelecionada?.destinatarioBairro,
                    numero: notaFiscalSelecionada?.destinatarioNumero,
                    logradouro: notaFiscalSelecionada?.destinatarioLogradouro,
                    cidade: notaFiscalSelecionada?.destinatarioCidade,
                    cep: notaFiscalSelecionada?.destinatarioCep,
                    condPag: notaFiscalSelecionada?.condicaoPagamento,
                    codigoCidade: notaFiscalSelecionada?.codigoCidade,
                    notaFiscalMae: notaFiscalSelecionada?.notaFiscalMae || undefined,
                    addRetirada: notaFiscalSelecionada?.addRetirada,
                    dataSaida: notaFiscalSelecionada?.dataSaida ? moment(notaFiscalSelecionada.dataSaida).format('YYYY-MM-DD') : undefined,
                    ncm: notaFiscalSelecionada?.ncm,
                    cest: notaFiscalSelecionada?.cest,
                    informacaoAdd: notaFiscalSelecionada?.informacaoAdd
                }

                this.notaFiscal.notaFiscalMae = selecionado?.chaveAcesso || ''
                this.componentKey += 1

            } else {
                this.notaFiscal = {}
            }

        },
    },
    async created(){
        try {
            const typeNf = this.$route.params.typeNf || 'Nota Fiscal';
            this.emitNotaFiscal.typeNf = typeNf

            const id = this.$route.query.id
            const duplicar = ['1', 'true', 'True'].includes(String(this.$route.query.duplicate || '').trim())
            this.isDuplicating = duplicar

            if(this.notaFiscal.notaFiscalMae && this.itemsData.length == 0){
                this.searchNotaChaveAcesso = this.notaFiscal.notaFiscalMae
                await this.searchNotaFisca()
            }

            if(id){
                await this.getItemNf(id, { duplicar })
            }

            if(this.emitNotaFiscal.typeNf != 'Nota Fiscal de Serviço') {
                await this.getJob(undefined)
            }

            if(this.emitNotaFiscal.typeNf == 'Nota Fiscal de Serviço') {
                await this.getClientes(undefined)
                await this.getJob(undefined, { usarRegraAberturaOs: true })
            }

            if(this.emitNotaFiscal.notaFiscalDeRemessa) await this.getFornecedores(undefined)
        } catch (error) {
            console.error('[CreateIssuance] Erro ao inicializar tela:', error)
            this.$notfy?.error('Não foi possível carregar a tela de emissão de nota fiscal.')
        }
    }
}
</script>

<style scoped>
.my-custom-dialog {
    margin: 0;
    margin-right: 10px;
    height: 100%;
    width: 565px;
    max-height: 100% !important;
}
.my-custom-card {
    min-height: 100%;
  }
</style>